import { useState, useEffect } from 'react';
import { buildApiUrl } from '../../common/api';

const DEFAULTS = {
  referral_perc_primo_ordine: 10,
  referral_perc_rolling_produttore: 1,
  referral_mesi_rolling_produttore: 12,
  closer_soglia_prelievo_minimo: 25,
};

/**
 * Hook pubblico per leggere le impostazioni marketing dal server.
 * Non richiede autenticazione. Fa fallback ai defaults in caso di errore.
 */
export function useImpostazioniMarketing() {
  const [impostazioni, setImpostazioni] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(buildApiUrl('/api/impostazioni-marketing-pubbliche'), {
      headers: { Accept: 'application/json' },
    })
      .then((r) => r.json())
      .then((data) => {
        if (data?.data) {
          const map = {};
          data.data.forEach((i) => {
            map[i.chiave] = parseFloat(i.valore);
          });
          setImpostazioni((prev) => ({ ...prev, ...map }));
        }
      })
      .catch(() => {
        // Silenziosa: usa defaults
      })
      .finally(() => setLoading(false));
  }, []);

  return { impostazioni, loading };
}
